import { InAppBrowser } from '@/src/common/components/InAppBrowser'
import { routerBack } from '@/src/common/utils/routerBack'
import { useLocalSearchParams } from 'expo-router'
import { useRefreshPoints } from '@/src/common/hooks/usePoints'

/**
 * Not exported from expo-router
 * @see /node_modules/expo-router/build/hooks.d.ts#L54
 */
type SearchParams = Record<string, string | string[]>

interface RouteSearchParams extends SearchParams {
  title: string
  loginLink: string
}

export default function Redemption() {
  // the InAppBrowser getting closed and this component unmounting are effectively the same thing.
  // there's a possibility that the user redemmed their points for something while they were in the browser.
  // let's refresh the points balance so that the user can see the updated balance if there is one
  useRefreshPoints()

  const { title, loginLink } = useLocalSearchParams<RouteSearchParams>()

  if (!title || !loginLink) {
    return null
  }

  return <InAppBrowser title={title} uri={loginLink} onBackPress={() => void routerBack()} />
}
